import * as React from "react";
import { forwardRef } from "react";
const SvgVector = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 7, height: 11, viewBox: "0 0 7 11", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M4.12477 5.50004L0.589247 1.96446C0.263815 1.63902 0.263817 1.11139 0.589254 0.785955C0.91469 0.460521 1.44233 0.460522 1.76776 0.785956L6.48185 5.50004L1.76776 10.214C1.44233 10.5395 0.914693 10.5395 0.589257 10.214C0.26382 9.88861 0.26382 9.36097 0.589259 9.03553L4.12477 5.50004Z", fill: "#03A3DB" }));
const ForwardRef = forwardRef(SvgVector);
export default ForwardRef;
